import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { RouteImage } from '../../assets/routeImage'
import { Stack, Chip, Button, Typography, styled } from '@mui/material'
import { swalError } from '../notification/swal'
import { handleDownload } from '../../utils/download'
import HelperText from '../input/helperText'
import { colors } from '../../constants/colors'

const UploadFileContainer = styled('span')(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        flexDirection: "column",
        justifyContent: 'center',
        alignItems: "center"
    },
    '.upload-file-content': {
        [theme.breakpoints.down('md')]: {
            textAlign: "center",
            flexDirection: "column"
        }
    }
}))

export type uploadFileProps = {
    heading?: string;
    onDrop: (data: any) => void;
    file?: any
    onDeleteFile?: () => void;
    fileAttachmentId?: number;
    fileAttachmentName?: string;
    noClick?: boolean;
    required?: boolean;
    helperText?: string;
    hidden?: boolean;
    formatName?: string;
}



const UploadFile = (props: uploadFileProps) => {
    const onDrop = useCallback((acceptedFiles: any) => {
        const file = acceptedFiles[0];
        if (file) {
            const allowedTypes = [
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            ];
            if (!allowedTypes.includes(file.type)) {
                swalError('รูปแบบไฟล์ไม่ถูกต้องกรุณาตรวจสอบ')
                return;
            }
            const maxSize = 10 * 1024 * 1024; // 10 MB
            if (file.size > maxSize) {
                swalError('ขนาดไฟล์ใหญ่เกินไป')
                return;
            }

            props.onDrop(acceptedFiles);
        }
    }, [props]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        maxFiles: 1,
        ...(props.noClick ? { noClick: true } : {}),
    })


    return (
        <div style={{ display: props.hidden ? 'none' : 'block' }} className='w-100'>
            {props.heading && (
                <div className='my-2 d-flex justify-content-start align-items-center gap-2'>
                    <Typography>{props.heading}</Typography>
                    {props.required && <Typography sx={{ color: colors.danger }}>*</Typography>}
                </div>
            )}
            <div style={{
                // pointerEvents: props.fileAttachmentId ? 'none' : 'all',
                border: "2px dotted #C1C3C7",
                borderRadius: "10px",
                padding: "15px 15px"
            }} {...getRootProps()}>
                <UploadFileContainer
                    className="flex justify-between gap-3">
                    <div className='upload-file-content flex gap-3 justify-start items-center'>
                        <span>
                            <img src={RouteImage.cloudIconUpload} alt="icon" />
                        </span>
                        <span className='flex justify-center flex-col'>
                            {isDragActive ?
                                <>
                                    <Typography sx={{ color: "#323539", fontSize: "14px", fontWeight: "500" }}>
                                        {"วางไฟล์ลงที่นี่"}
                                    </Typography>
                                    <Typography sx={{ color: 'rgba(0,0,0,0.40)', fontSize: '14px', fontWeight: "300" }}>
                                        {"Drop the file here."}
                                    </Typography>
                                </> :
                                <>
                                    <Typography sx={{ color: "#323539", fontSize: "14px", fontWeight: "500" }}>
                                        {"เลือกไฟล์เพื่ออัพโหลด"}
                                    </Typography>
                                    <Typography sx={{ color: 'rgba(0,0,0,0.40)', fontSize: '14px', fontWeight: "300" }}>
                                        {props.formatName ? props.formatName : "Word, Excel or PDF ขนาดไม่เกิน 10MB"}
                                    </Typography>
                                </>
                            }
                        </span>
                        <span>
                            <Stack spacing={1}>
                                {props.file ?
                                    <Chip
                                        onDelete={props.onDeleteFile}
                                        label={props.file[0]?.name}
                                    />
                                    :
                                    <>
                                    </>
                                }
                                {props.fileAttachmentId
                                    &&
                                    props.fileAttachmentName &&
                                    <Chip
                                        label={props.fileAttachmentName?.length > 34 ? props.fileAttachmentName?.substring(0, 34) + "..." : props.fileAttachmentName}
                                    />
                                }
                            </Stack>
                        </span>
                    </div>
                    <div>
                        {props?.fileAttachmentId && props.fileAttachmentName ?
                            <>
                                <Button
                                    onClick={() => handleDownload(props.fileAttachmentId, props.fileAttachmentName)}
                                    variant='outlined' color='primary'>
                                    ดาวน์โหลด
                                </Button>
                            </>
                            :
                            <>
                                <Button variant='outlined' color='primary'>
                                    เลือกไฟล์
                                </Button>
                            </>
                        }

                    </div>
                </UploadFileContainer>
                <input accept='.xlsx,.xls,pdf,.docx' multiple={false} {...getInputProps()} />
            </div>
            {props.helperText ? <HelperText label={props.helperText} /> : ""}
        </div>
    )
}

export default UploadFile

